import * as React from "react";
import { Route, Switch } from "react-router-dom";
import moment from "moment";
import * as Glob from "../Globale";
import { Trad, BottoneAPI, AsideMenu } from "../components/";
import * as Dati from "../Dati";
import * as Form from "../form/";
import { Header, Footer } from "../layout/";
import * as H from "history";
import * as Pages from "../inar2/pages";
import { AlertDialogProvider } from "../inar2/providers/AlertDialogProvider";

moment.locale("it");

export class Layout extends React.Component<{}, Glob.IGlobaleState> {
    constructor(props: any) {
        super(props);
        this.state = { Globale: Glob.Globale.Init() };
    }

    public SetGlobale(G: number, V: any) {
        this.state.Globale[G] = V;
        this.setState({ Globale: this.state.Globale });
        switch (G) {
            case Glob.TTipiGlobale.Locale:
                localStorage.setItem("Locale", JSON.stringify(V));
                break;
            case Glob.TTipiGlobale.Menu:
                localStorage.setItem("Menu", JSON.stringify(V));
                break;
            case Glob.TTipiGlobale.Sessione:
                localStorage.setItem("Sessione", JSON.stringify(V));
                break;
        }
    }

    public SetLocale(V: Glob.CLocale) {
        Trad.Lingua = V.Lingua;
        moment.locale(V.Lingua);
        this.SetGlobale(Glob.TTipiGlobale.Locale, V);
    }

    public SetSessione(V: Glob.CSessione) {
        this.SetGlobale(Glob.TTipiGlobale.Sessione, V);
    }

    public SetMenu(V: Glob.CMenu) {
        this.SetGlobale(Glob.TTipiGlobale.Menu, V);
    }

    componentDidMount() {
        window.addEventListener("popstate", () => {
            Glob.AddMetronicStyles("metronicVendors", "assets/metronic/vendors.min.css");
            Glob.AddMetronicStyles("metronicMain", "assets/metronic/main-styles.css");
        });
    }

    public render() {
        return (
            <AlertDialogProvider>
                <LayoutGlobale
                    {...(this.props as any)}
                    Globale={this.state.Globale}
                    SetGlobale={(g: number, v: any) => this.SetGlobale(g, v)}
                    SetLocale={(v: any) => this.SetLocale(v)}
                    SetMenu={(v: any) => this.SetMenu(v)}
                    SetSessione={(v: any) => this.SetSessione(v)}
                />
            </AlertDialogProvider>
        );
    }

    public static OnClickUrl(sender: BottoneAPI, dati: Dati.CRisAPISemplice<string>, history: H.History) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            history.push(dati.Dato);
        }
    }

    public static GetTemplateUrl(tipo: string): string {
        let url: string = "";
        switch (tipo) {
            case Glob.Tipi_DT_Polizza: {
                url = "/anagrafica/:ID_Anag/fideaffidamento/:ID_FideAffidamento/FidePolizza/:ID_Polizza";
                break;
            }
            case Glob.Tipi_DT_Fideiussione: {
                url = "/anagrafica/:ID_Anag/fideaffidamento/:ID_FideAffidamento";
                break;
            }
            case Glob.Tipi_DT_PolizzaNeutra: {
                url = "/anagrafica/:ID_Anag/polizzaneutra/:ID_Polizza";
                break;
            }
            case Glob.Tipi_DT_CAR: {
                url = "/anagrafica/:ID_Anag/polizzacar/:ID_Polizza";
                break;
            }
            default: {
                url = "";
                break;
            }
        }
        return url;
    }
}

export class LayoutGlobale extends React.Component<{}, Glob.IGlobaleProps> {
    public render() {
        return (
            <Switch>
                <Route path="/login" render={props => <Pages._Login {...(props as any)} {...(this.props as any)} />} />
                <Route path="/logout" render={props => <Pages._Logout {...(props as any)} {...(this.props as any)} />} />
                <Route path="/utente/:ID_Utente" render={props => <Pages._User {...(props as any)} {...(this.props as any)} />} />
                <Route path="/utente" render={props => <Pages._UsersList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/polizza/:ID_TipoRamo/:ID_Anag" render={props => <Pages._PoliciesList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/polizza/:ID_TipoRamo" render={props => <Pages._PoliciesList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/polizza" render={props => <Pages._PoliciesList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/renewals" render={props => <Pages._RenewalPoliciesList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/affidamenti" render={props => <Pages._ExposureLimitsSearch {...(props as any)} {...(this.props as any)} />} />
                <Route exact path={`${Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione)}/FidePolizza`} render={props => <Pages._BondsList {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/anagrafica" render={props => <Pages._ClientsList {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/anagrafica/:ID_Anag" render={props => <Pages._ClientDetails {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/anagrafica/:ID_Anag/fideaffidamento" render={props => <Pages._ExposureLimitsList {...(props as any)} {...(this.props as any)} />} />
                <Route
                    exact
                    path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/FideValutazione"}
                    render={props => <Pages._BondsAssessmentList {...(props as any)} {...(this.props as any)} />}
                />
                <Route
                    path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/FideValutazione/:ID_FideValutazione"}
                    render={props => <Pages._BondsAssessment {...(props as any)} {...(this.props as any)} />}
                />
                <Route path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/coobbligato"} render={props => <Pages._BondsCoobligated {...(props as any)} {...(this.props as any)} />} />
                <Route
                    path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/FidePolizza/:ID_Polizza/coobbligato"}
                    render={props => <Pages._BondsCoobligated {...(props as any)} {...(this.props as any)} />}
                />
                <Route path="/anagrafica/:ID_Anag/datieconomici/:ID_DatoEconomico" render={props => <Pages._EconomicData {...(props as any)} {...(this.props as any)} />} />
                <Route
                    path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/datieconomici/:ID_DatoEconomico"}
                    render={props => <Pages._EconomicData {...(props as any)} {...(this.props as any)} />}
                />
                <Route path="/anagrafica/:ID_Anag/datieconomici" render={props => <Pages._EconomicDataList {...(props as any)} {...(this.props as any)} />} />
                <Route path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/datieconomici"} render={props => <Pages._EconomicDataList {...(props as any)} {...(this.props as any)} />} />

                <Route exact path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione) + "/:DataRiferimento"} render={props => <Pages._ExposureLimit {...(props as any)} {...(this.props as any)} />} />
                <Route exact path={Layout.GetTemplateUrl(Glob.Tipi_DT_Fideiussione)} render={props => <Pages._ExposureLimit {...(props as any)} {...(this.props as any)} />} />
                <Route path="/fidenuovo" render={props => <Pages._NewBond {...(props as any)} {...(this.props as any)} />} />
                <Route path="/createneutral" render={props => <Pages._NewNeutral {...(props as any)} {...(this.props as any)} />} />
                <Route path="/createpolicycar" render={props => <Pages._NewPolicyCAR {...(props as any)} {...(this.props as any)} />} />
                <Route path="/FideCodiceControllo/:CodiceControllo/:Polizza" render={props => <Pages._BondCheckCode {...(props as any)} {...(this.props as any)} />} />
                <Route path="/FideCodiceControllo/:CodiceControllo" render={props => <Pages._BondCheckCode {...(props as any)} {...(this.props as any)} />} />
                <Route path="/FideCodiceControllo" render={props => <Pages._BondCheckCode {...(props as any)} {...(this.props as any)} />} />
                <Route path="/binder/:ID_Binder/fidetassi" render={props => <Pages._BondsRates {...(props as any)} {...(this.props as any)} />} />
                <Route path="/binder/:ID_Binder/provvigioni/" render={props => <Pages._Commissions {...(props as any)} {...(this.props as any)} />} />
                <Route path={Layout.GetTemplateUrl(Glob.Tipi_DT_Polizza)} render={props => <Pages._Bond {...(props as any)} {...(this.props as any)} />} />
                <Route path={Layout.GetTemplateUrl(Glob.Tipi_DT_PolizzaNeutra)} render={props => <Pages._PolicyNeutral {...(props as any)} {...(this.props as any)} />} />
                <Route path={Layout.GetTemplateUrl(Glob.Tipi_DT_CAR)} render={props => <Pages._PolicyCAR {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/binder" render={props => <Pages._BindersList {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/Contabilita/FattureDatiEconomici" render={props => <Pages._InvoicesList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/quietanza" render={props => <Pages._ReceiptsList {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/Gruppo" render={props => <Pages._GroupList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/Deroga" render={props => <Pages._SpecialAcceptanceList {...(props as any)} {...(this.props as any)} />} />
                <Route exact path="/EstrattoConto" render={props => <Pages._AccountBalanceList {...(props as any)} {...(this.props as any)} />} />
                <Route path="/ErroreAccesso" render={props => <Pages._AccessError {...(props as any)} {...(this.props as any)} />} />

                <div className="kt-grid kt-grid--hor kt-grid--root">
                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                        <Switch>
                            <Route path="/dpa/Sessione/:Sessione" render={props => <Form.AnalysersList {...(props as any)} {...(this.props as any)} />} />
                            <Route path="/dpa/cps/Sessione/:Sessione" render={props => <Form.PrimaryAnalyser {...(props as any)} {...(this.props as any)} />} />
                            <Route path="/dpa/dps/Sessione/:Sessione" render={props => <Form.PrimaryAnalyser IsDpsPage {...(props as any)} {...(this.props as any)} />} />
                            <Route path="/dpa/pensioners/Sessione/:Sessione" render={props => <Form.PensionersAnalyser {...(props as any)} {...(this.props as any)} />} />
                            <>
                                <AsideMenu {...(this.props as any)} />
                                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
                                    <Header {...(this.props as any)} />
                                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                                        <div className="kt-content  kt-grid__item kt-grid__item--fluid">
                                            <Switch>
                                                <Route path="/log/:LogCat?/:Abilita?" render={props => <Form.Log {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/costanti" render={props => <Form.Costanti {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/file/:ID_Chiave/:ID_File" render={props => <Form.FileDett {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/file/:ID_Chiave" render={props => <Form.FileLista {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/testapi" render={props => <Form.TestAPI {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/test" render={props => <Form.Test1 {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/dashboard" render={props => <Form.Dashboard {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/documents" render={props => <Form.DocumentsList {...(props as any)} {...(this.props as any)} />} />
                                                <Route
                                                    path="/binder/:ID_Binder/BinderProdottiGaranzie/"
                                                    render={props => <Form.BinderProdottoGaranzia {...(props as any)} {...(this.props as any)} />}
                                                />
                                                <Route path="/binder/:ID_Binder" render={props => <Form.Binder {...(props as any)} {...(this.props as any)} />} />
                                                <Route
                                                    path="/Contabilita/FattureDatiEconomici/:ID_FatturaDatiEconomici"
                                                    render={props => <Form.FattureDatiEconomici {...(props as any)} {...(this.props as any)} />}
                                                />

                                                <Route path="/RCPComparatore/:ID_Polizza" render={props => <Form.RCPComparatore {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/RCPComparatoreNew/:ID_Polizza" render={props => <Form.RCPComparatoreNew {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/RCPPolizza/:ID_Polizza/RCPAppendice/:ID_Appendice" render={props => <Form.RCPAppendice {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/RCPPolizza/:ID_Polizza" render={props => <Form.RCPPolizza {...(props as any)} {...(this.props as any)} />} />
                                                
                                                
                                                <Route path="/anagrafica/:ID_Anag/RCPPolizza/:ID_Polizza" render={props => <Form.RCPPolizza {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/Appendice" render={props => <Form.AddendumList {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/anagrafica/:ID_Anag/RCPComparatore/:ID_Polizza" render={props => <Form.RCPComparatore {...(props as any)} {...(this.props as any)} />} />

                                                <Route path="/RCPPolizzaRinnovo/:ID_Polizza" render={props => <Form.RCPPolizzaRinnovo {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/anagrafica/:ID_Anag/RCPPolizzaRinnovo/:ID_Polizza" render={props => <Form.RCPPolizzaRinnovo {...(props as any)} {...(this.props as any)} />} />

                                                
                                                <Route
                                                    path="/anagrafica/:ID_Anag/RCPPolizza/:ID_Polizza/RCPAppendice/:ID_Appendice"
                                                    render={props => <Form.RCPAppendice {...(props as any)} {...(this.props as any)} />}
                                                />
                                                <Route
                                                    path="/anagrafica/:ID_Anag/RCPComparatoreNew/:ID_Polizza"
                                                    render={props => <Form.RCPComparatoreNew {...(props as any)} {...(this.props as any)} />}
                                                />
                                                <Route path="/Gruppo/:ID_Gruppo" render={props => <Form.Gruppo {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/EstrattoContoQuietanze" render={props => <Form.EstrattoContoQuietanze {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/EstrattoConto/:ID_EstrattoConto" render={props => <Form.EstrattoContoDettagli {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/news/:ID_News" render={props => <Form.News {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/news" render={props => <Form.NewsList {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/RecuperaPassword/:Codice" render={props => <Form.RecuperaPassword {...(props as any)} {...(this.props as any)} />} />
                                                <Route path="/" render={props => <Form.Dashboard {...(props as any)} {...(this.props as any)} />} />
                                            </Switch>
                                        </div>
                                    </div>
                                    <div className="kt-subheader kt-grid__item submenu-new-line" id="kt_subheader" />
                                    <Footer className="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" {...(this.props as any)} />
                                </div>
                            </>
                        </Switch>
                    </div>
                </div>
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/Layout.tsx